<div class="container-fluid" id="body">
    <div class="row">
        <div class="col-12" *ngIf="isLoading">
            <app-busy [message]="message"></app-busy>
        </div>
    </div>
    <div class="row">

        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <strong>Consultants</strong> for {{carrier_name}}
                    <br>
                    <br>
                </div>
            </div>

            <fieldset style="margin:0px;padding:0px;">
                <div class="row" style="margin:0px auto!important;padding:0px">
                    <div class="col-12" style="margin:0px!important;padding:0px!important;">
                        <div style="padding-top: 10px;padding-bottom: 20px;">
                            <app-filter></app-filter>
                        </div>
                    </div>
                </div>
            </fieldset>

            <button id="btnSearch" style="width: 0px; display: none;" (click)="onSearch()" visibility="hidden">
            </button>

            <div class="row">
                <div class="col-12">
                    <button class="btn btn-add_2" id="btnAddConsultant" data-toggle="modal" data-target="#addNewConsultantPopUp">Add
                        Consultant
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="actions screen">
                        <div class="container" class="overlap-group3">
                            <div class="row">
                                <div *ngIf="selectedCons && selectedCons?.status != 'Inactive' && selectedCons?.status != 'inactive'"
                                     class="col-sm">
                                    <button [routerLink]="" class="btn btn-default"
                                            (click)="selectOptionList('0',selectedCons)">
                                        <img src="../assets/newimg/folder-dublicate-fill@2x.svg" width="24"
                                             height="24"/>
                                        <span class="hidden-xs hidden-sm">Mark As Inactive</span>
                                    </button>
                                </div>

                                <div class="col-sm">
                                    <button *ngIf="selectedCons" class="btn btn-default"
                                            (click)="selectOptionList('1',selectedCons)">
                                        <img src="../assets/newimg/folder-dublicate-fill@2x.svg" width="24"
                                             height="24"/>
                                        <span class="hidden-xs hidden-sm">Change User Role</span>
                                    </button>
                                </div>

                                <div class="col-sm">
                                    <button
                                            *ngIf="selectedCons && selectedCons?.status == 'Inactive' || selectedCons?.status == 'inactive'"
                                            class="btn btn-default" (click)="selectOptionList('2',selectedCons)">
                                        <img src="../assets/newimg/folder-dublicate-fill@2x.svg" width="24"
                                             height="24"/>
                                        <span class="hidden-xs hidden-sm">Resend User OTP</span>
                                    </button>
                                </div>
                                <br/>
                            </div>
                        </div>
                        <div class="overlap-group3" style="display:none">
                            <img class="border_color" src="../assets/newimg/border-color@2x.png" alt="border_color"/>
                            <div class="group-container">
                                <div class="group-280"></div>
                                <div class="overlap-group-group-container">
                                    <div class="change-route opensans-normal-sapphire-14px">Change route</div>
                                    <img class="pointers_fill" src="../assets/newimg/pointers-fill@2x.svg"
                                         alt="Pointers_fill"/>
                                </div>
                                <div class="overlap-group-group-container">
                                    <div class="change-route opensans-normal-sapphire-14px">Change routes</div>
                                    <img class="pointers_fill" src="../assets/newimg/pointers-fill@2x.svg"
                                         alt="Pointers_fill"/>
                                </div>
                                <div class="group-277">
                                    <div class="ic24-car"><img class="icon" src="../assets/newimg/icon@2x.svg"
                                                               alt="Icon"/></div>
                                    <div class="replace-vehicle opensans-normal-sapphire-14px">Replace vehicle</div>
                                </div>
                                <!-- <div class="group-274">
                                    <div class="date_range_fill">
                                        <div class="overlap-group-date_range_fill">
                                            <img class="rectangle-26" src="../assets/newimg/rectangle-26@2x.svg" alt="Rectangle 26" />
                                            <img class="line-1" src="../assets/newimg/line-1@2x.svg" alt="Line 1" />
                                            <img class="line-2" src="../assets/newimg/line-2@2x.svg" alt="Line 2" />
                                        </div>
                                        <img class="subtract-date_range_fill" src="../assets/newimg/subtract@2x.svg" alt="Subtract" />
                                    </div>
                                    <div class="apply-for-annual-compliance opensans-normal-sapphire-14px">Apply for annual compliance</div>
                                </div> -->
                                <div class="group-279">
                                    <img class="folder_dublicate_fill"
                                         src="../assets/newimg/folder-dublicate-fill@2x.svg"
                                         alt="Folder_dublicate_fill"/>
                                    <div class="apply-for-duplicate opensans-normal-sapphire-14px">Apply for duplicate
                                    </div>
                                </div>
                                <div class="overlap-group1">
                                    <div class="apply-for-change opensans-normal-sapphire-14px">Apply for change</div>
                                    <div class="edit_fill"><img class="subtract-edit_fill"
                                                                src="../assets/newimg/subtract-1@2x.svg"
                                                                alt="Subtract"/></div>
                                </div>
                                <!-- <div class="group-273">
                                    <div class="credit-card_fill">
                                        <img class="subtract-credit-card_fill" src="../assets/newimg/subtract-2@2x.svg" alt="Subtract" />
                                    </div>
                                    <div class="pay-account opensans-normal-sapphire-14px">Pay account</div>
                                </div> -->
                                <!-- <div class="group-275">
                                    <div class="alarmclock_fill">
                                        <div class="overlap-group-alarmclock_fill">
                                            <img class="vector-65" src="../assets/newimg/vector-65@2x.svg" alt="Vector 65" />
                                            <img class="vector-66" src="../assets/newimg/vector-66@2x.svg" alt="Vector 66" />
                                            <img class="subtract-overlap-group" src="../assets/newimg/subtract-3@2x.svg" alt="Subtract" />
                                        </div>
                                    </div>
                                    <div class="change-timetable opensans-normal-sapphire-14px">Change timetable</div>
                                </div> -->
                            </div>
                            <!-- <div class="group-307">
                                <img class="vector" src="../assets/newimg/vector@2x.svg" alt="Vector" />
                                <div class="confirm-complete opensans-normal-sapphire-14px">Confirm &amp; complete</div>
                            </div>
                            <div class="group-308">
                                <img class="icon-star" src="../assets/newimg/icon-1@2x.svg" alt="icon-star" />
                                <div class="renew opensans-normal-sapphire-14px">Renew</div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
            <table id="dt-all-checkbox" class="table" cellspacing="0" width="100%">
                <thead>
                <tr>
                    <th><input type="checkbox" [checked]="isAllCheckBoxChecked()" (change)="checkAllCheckBox($event)">
                    </th>
                    <th class="th-sm">Username</th>
                    <th class="th-sm">Email</th>
                    <th class="th-sm">Mobile Number</th>
                    <th class="th-sm">Phone Number</th>
                    <th class="th-sm">Status</th>
                    <th class="th-sm">Role</th>
                    <!--            <th class="th-sm"></th>-->
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let cons of consultants | paginate: { itemsPerPage: 10, currentPage: page }">
                    <td><input type="checkbox" value="{{cons.id}}" (change)="CheckedConsultant($event,cons.id,cons)">
                    </td>
                    <td>{{cons.username}}</td>
                    <td>{{cons.email}}</td>
                    <td>{{cons.mobile}}</td>
                    <td>{{cons.phone}}</td>
                    <td>{{cons.status}}</td>
                    <td>
                        <div *ngIf="cons.role == 1">Lead User</div>
                        <div *ngIf="cons.role == 2">Editor User</div>
                        <div *ngIf="cons.role == 6">Read User</div>
                        <div *ngIf="cons.role == 11">Owner</div>
                        <div *ngIf="cons.role == 12">Consultant</div>
                        <div *ngIf="cons.role == 21">Main Contact</div>
                    </td>
                    <!--          <td class="btn-show">-->
                    <!--            <select class="form-control" (change)="selectOptionList(select.value,cons)" #select>-->
                    <!--              <option>Select</option>-->
                    <!--              <option value="0" *ngIf="cons.status != 'Inactive' && cons.status != 'inactive'">Mark As Inactive</option>-->
                    <!--              <option value="1">Change User Role</option>-->
                    <!--              <option value="2" *ngIf="cons.status == 'Inactive' || cons.status == 'inactive'">Resend User OTP</option>-->
                    <!--            </select>-->
                    <!--          </td>-->

                </tr>
                </tbody>
            </table>
        </div>
    </div>
    <br>
    <br/>
    <div class="pull-right">
        <button class="btn btn-add_2" title="Go Back" (click)="cancel()">Cancel</button>
    </div>

    <button data-toggle="modal" data-target="#modalPopup" id="secretButton" style="display:none"></button>

    <div #thisModal class="modal fade form-group" id="modalPopup"
         data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5);">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content bgd-c" style="border:none!important;">
                <div class="modal-body" style="border:none!important;">
                    <p class="h6" id="PopupTitle">{{title || 'Confirmation'}}</p>
                    <small class="extra-clr ft-c">{{message}}</small><br/>
                    <small class="text-small"
                           style="font-size:10px!important">{{'Please select role you want to give user before proceeding'}}</small>
                    <select #roleServed (change)="roleChange(roleServed)" class="form-control form-control-sm"
                            name="role" style="margin-top: 10px; margin-bottom: 5px;">
                        <option value="" disabled selected>Select Role</option>
                        <option *ngFor="let role of roles" [value]="role.role">{{role.desc}}</option>
                    </select>
                    <div style="border:none!important;height:20px!important;margin-top:10px!important;">
                        <button type="button" data-dismiss="modal" class="btn btn-danger btn-sm pull-right"
                                style="margin-right:4px!important;">{{'Cancel'}}</button>
                        <button [disabled]="proceedDisabled" type="button" data-dismiss="modal"
                                class="btn btn-primary btn-sm pull-right"
                                style="margin-right:4px!important;padding-right:4px!important;"
                                (click)="confirm(thisModal)">{{'Proceed'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- Modal -->

<div class="modal fade bd-example-modal-lg" id="addNewConsultantPopUp" tabindex="-1" role="dialog" aria-labelledby="addNewConsultantPopUp"
     aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalCenterTitle">Link New Consultant</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
            <div class="modal-body">
            <div class="row">
                <div class="col-12">
                    <label class="control-label hd-cat">
                        <strong>Linking Options</strong>
                    </label>

                    <h5>Link consultant by email :</h5>
                    <br/>
                    <input type="text" style="margin:0px;padding:0px; padding-left: 8px;" [(ngModel)]="user_email"
                           name="user_email" class="form-control form-control-sm" placeholder="Enter email"/>
                    <br/>
                    Or
                    <br/>
                    <br>
                    <h5>Link consultant by username:</h5>
                    <input type="text" style="margin:0px;padding:0px; padding-left: 8px;" [(ngModel)]="username"
                           name="username" class="form-control form-control-sm" placeholder="Enter username"/>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-custom" data-dismiss="modal">Close</button>
            <button class="btn  btn-add_2" title="Link Selected User" (click)="linkUser()">Link Consultant</button>
        </div>
        </div>
    </div>
</div>






